import { useTranslation } from "react-i18next";

const cardOriginOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "domestic",
      title: t("options.cardOrigin.domestic"),
      value: "DOMESTIC",
    },
    {
      key: "foreign",
      title: t("options.cardOrigin.foreign"),
      value: "FOREIGN",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default cardOriginOptions;
